<ion-content class="ion-no-padding">
  <form class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">PayU Payment Invoice ({{txnId}})</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" (click)="openDownloadPopover($event)">
            Download
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content" >
      <div class="d-flex justify-content-center" [innerHTML]="invoiceHtml">
        <!-- Putting rendered html data here -->
      </div>
    </div>

  </form>
</ion-content>



<!-- ---------------------- -->
  